export const stats = {
  organisations: 10,
  members: 103,
  youth: '10,350+',
};

export const focusAreas = [
  'STEM Education',
  'Entrepreneurship',
  'Leadership Development',
  'Digital Skills',
  'Innovation Labs',
  'Governance',
];

export const pillars = [
  {
    roman: 'I',
    title: 'Consultancy',
    desc: 'We work directly with organisational leadership to strengthen systems, programmes, strategy, and operations.',
    img: 'https://images.unsplash.com/photo-1632215861513-130b66fe97f4?auto=format&fit=crop&q=80&w=1400',
  },
  {
    roman: 'II',
    title: 'Skills-Based Support',
    desc: 'We connect organisations with diaspora professionals providing pro bono expertise in tech, finance, strategy, fundraising, and more.',
    img: 'https://images.unsplash.com/photo-1644152993066-9b9ee687930d?auto=format&fit=crop&q=80&w=1200',
  },
  {
    roman: 'III',
    title: 'Physical Resource Provision',
    desc: 'We audit the resources our organisations use and, where needed, fill the gaps or expand capacity so they can reach and serve more students.',
    img: 'https://images.unsplash.com/photo-1533108344127-a586d2b02479?auto=format&fit=crop&q=80&w=1200',
  },
];

export const diasporaFeatures = [
  { n: '01', title: 'High-impact matches', desc: 'We match your expertise to an organisation where your 8 hours will move the needle.' },
  { n: '02', title: 'Monthly webinars', desc: 'Live sessions on building, investing, and creating impact in Nigeria.' },
  { n: '03', title: 'A serious network', desc: 'Ambitious professionals across industries — diaspora and homeland.' },
  { n: '04', title: 'In-person events', desc: 'Networking, meetups, and retreats. Membership is free by application.' },
];

export const organisations = [
  { id: 1, name: 'Code the Delta', tag: 'Digital Skills', city: 'Port Harcourt', desc: 'Coding academies in the Niger Delta connecting talented young people to global remote work.', reached: '5,600', site: 'https://example.org/codethedelta' },
  { id: 2, name: 'LeadNaija', tag: 'Leadership', city: 'Ibadan', desc: 'Building the next generation of civic and organisational leaders across 12 Nigerian states.', reached: '8,900', site: 'https://example.org/leadnaija' },
  { id: 3, name: 'Founders Institute Africa', tag: 'Entrepreneurship', city: 'Abuja', desc: 'Entrepreneurship bootcamps that turn Nigerian graduates into founders solving local problems.', reached: '3,400', site: 'https://example.org/foundersafrica' },
  { id: 4, name: 'STEMinAfrica', tag: 'STEM', city: 'Lagos', desc: 'Advancing STEM education for underserved Nigerian youth through hands-on learning labs and teacher training.', reached: '12,500', site: 'https://example.org/steminafrica' },
];

export const howItWorks = [
  { n: '01', title: 'Apply', desc: 'Fill in a short application. Free, always.' },
  { n: '02', title: 'Match', desc: 'We match your expertise to an organisation.' },
  { n: '03', title: 'Contribute', desc: '4 weeks. Focused deliverables. Real outcomes.' },
  { n: '04', title: 'Belong', desc: 'Stay in the network. Access webinars & events.' },
];

export const webinars = [
  { id: 1, date: 'Nov 14', title: 'Building in Nigeria: a founder\'s reality check', speaker: 'Yemisi Adekunle · Partner, TLcom' , tag: 'Investing' },
  { id: 2, date: 'Dec 05', title: 'Diaspora tech: from remote to on-the-ground impact', speaker: 'Chidi Okonkwo · Head of Eng, Flutterwave', tag: 'Tech' },
  { id: 3, date: 'Jan 09', title: 'Capacity, not charity: what NGOs actually need', speaker: 'Amaka Ibe · MD, Vemoye', tag: 'Ecosystem' },
];

export const heroImg = 'https://images.unsplash.com/photo-1617056239820-8ce90ba48193?auto=format&fit=crop&q=80&w=1800';
export const lagosImg = 'https://images.unsplash.com/photo-1559585888-6b01c8ea796b?auto=format&fit=crop&q=80&w=1800';
